export const event = (name, props = undefined) => {
  if (window.plausible) {
    window.plausible(name, { props: props });
  } else {
    console.log({ name, props });
  }
};
